module.exports = __webpack_public_path__ + "img/mirna-anzaldo-byn.01fb9504.jpg";